// Feb 20, 2026 — VoucherEmptyListener.
//
// Mounts once at app root. Listens for `mysilo:voucher-empty` window
// events (dispatched by the api.js axios interceptor when a 402
// SILO_VOUCHER_EMPTY response comes back). Shows a sticky toast with a
// "Top up" action that opens the VoucherTopupModal pre-focused on the
// silo that triggered the block.
//
// Also re-fires on login if any of the creator's silos are currently
// at $0 (gentle nudge, not modal-spammy).
import { useEffect, useState } from "react";
import { toast } from "sonner";
import VoucherTopupModal from "@/components/VoucherTopupModal";

export default function VoucherEmptyListener() {
  const [open, setOpen] = useState(false);
  const [focusedSilo, setFocusedSilo] = useState(null);

  useEffect(() => {
    const onEmpty = (e) => {
      const d = e?.detail || {};
      const siloName = d.silo_name || "this silo";
      const siloId = d.silo_id || null;
      toast(
        `Platform credit empty for ${siloName}`,
        {
          description:
            d.message ||
            "Top up to keep Silo Wars, non-Gemini models, and refinery working. BYOK calls are unaffected.",
          action: {
            label: "Top up",
            onClick: () => {
              setFocusedSilo(siloId);
              setOpen(true);
            },
          },
          duration: 10_000,
        }
      );
    };
    window.addEventListener("mysilo:voucher-empty", onEmpty);
    return () => window.removeEventListener("mysilo:voucher-empty", onEmpty);
  }, []);

  return (
    <VoucherTopupModal
      open={open}
      onClose={() => setOpen(false)}
      onSuccess={() => setOpen(false)}
      prefocusedSiloId={focusedSilo}
    />
  );
}
